import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    FaYoutube,
    FaWhatsapp,
    FaInstagram,
    FaXTwitter,
    FaFacebook
} from "react-icons/fa6";

const siteLogo = `${process.env.PUBLIC_URL}/img/Logo.png`;

const BASE = (() => {
    let url =
        process.env.REACT_APP_API_URL ||
        "https://news-portal-l6pf.onrender.com";
    url = url.replace(/\/$/, "");
    if (url.endsWith("/api")) url = url.slice(0, -4);
    return url;
})();

const CATEGORY_API = `${BASE}/api/news/categories`;

const Footer = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await fetch(CATEGORY_API);
            const result = await res.json();
            const data = result?.categories || result?.data || [];
            setCategories(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Footer category error:", err);
        }
    };

    const groupedCategories = categories.reduce((acc, cat) => {
        const group = cat.group || "General";
        if (!acc[group]) acc[group] = [];
        acc[group].push(cat.name);
        return acc;
    }, {});

    return (
        <footer
            style={{
                background: "#fff",
                borderTop: "1px solid #eee",
                marginTop: "50px",
                padding: "40px 0 10px",
            }}
        >
            <Container>

                <Row>

                    {/* ABOUT */}
                    <Col md={3} className="mb-4">
                        <img src={siteLogo} alt="logo" style={{ height: "90px" }} />
                        <p style={{ marginTop: "10px", color: "#555" }}>
                            ProudTapi News brings latest updates from Gujarat,
                            India and around the world.
                        </p>
                    </Col>

                    {/* MAIN MENU */}
                    <Col md={3} className="mb-4">
                        <h6 className="fw-bold">Main Menu</h6>
                        <Link to="/" style={linkStyle}>Home</Link>
                        <Link to="/special" style={linkStyle}>ProudTaapi Special</Link>
                        <Link to="/top-news" style={linkStyle}>Top News</Link>
                        <Link to="/more" style={linkStyle}>More</Link>
                        <Link to="/epaper" style={linkStyle}>E-Paper</Link>
                    </Col>

                    {/* MY GUJARAT */}
                    <Col md={2} className="mb-4">
                        <h6 className="fw-bold">My Gujarat</h6>
                        {(groupedCategories["Maru Gujarat"] || []).slice(0, 6).map((cat, i) => (
                            <Link
                                key={i}
                                to={`/category/${encodeURIComponent(cat)}`}
                                style={linkStyle}
                            >
                                {cat}
                            </Link>
                        ))}
                    </Col>

                    {/* INDIA */}
                    <Col md={2} className="mb-4">
                        <h6 className="fw-bold">India States</h6>
                        {(groupedCategories["India"] || []).slice(0, 6).map((cat, i) => (
                            <Link
                                key={i}
                                to={`/category/${encodeURIComponent(cat)}`}
                                style={linkStyle}
                            >
                                {cat}
                            </Link>
                        ))}
                    </Col>

                    {/* WORLD */}
                    <Col md={2} className="mb-4">
                        <h6 className="fw-bold">World</h6>
                        {(groupedCategories["World"] || []).slice(0, 6).map((cat, i) => (
                            <Link
                                key={i}
                                to={`/category/${encodeURIComponent(cat)}`}
                                style={linkStyle}
                            >
                                {cat}
                            </Link>
                        ))}
                    </Col>

                </Row>

                <hr />

                {/* SOCIAL ICONS */}
                <Row className="mb-3">
                    <Col>
                        <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                            <a href="https://www.youtube.com/@PROUDTAPINEWS" target="_blank" rel="noreferrer">
                                <FaYoutube size={20} color="red" />
                            </a>
                            <a href="https://chat.whatsapp.com/HTBbi8H4L222bFEFI368kK" target="_blank" rel="noreferrer">
                                <FaWhatsapp size={20} color="green" />
                            </a>
                            <a href="https://www.instagram.com/proud_tapi_news" target="_blank" rel="noreferrer">
                                <FaInstagram size={20} color="#E1306C" />
                            </a>
                            <a href="https://x.com/ProudTapi" target="_blank" rel="noreferrer">
                                <FaXTwitter size={20} />
                            </a>
                            <a href="https://www.facebook.com/share/1CfZwrWSsH/" target="_blank" rel="noreferrer">
                                <FaFacebook size={20} color="#1877F2" />
                            </a>
                        </div>
                    </Col>
                </Row>

                {/* ✅ DREAMIT LINK — DO NOT REMOVE */}
                <div style={{ textAlign: "center", borderTop: "1px solid #eee", paddingTop: "10px" }}>
                    <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                        © {new Date().getFullYear()} ProudTapi News. All Rights Reserved.
                    </p>

                    <p style={{ margin: "4px 0", fontSize: "14px" }}>
                        Developed by{" "}
                        <a
                            href="https://www.dreamitinfotech.in/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "#0d6efd",
                                fontWeight: 600,
                                textDecoration: "none"
                            }}
                            onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                            onMouseOut={(e) => e.target.style.textDecoration = "none"}
                        >
                            Dreamit Infotech Pvt. Ltd.
                        </a>
                    </p>
                </div>

            </Container>
        </footer>
    );
};

const linkStyle = {
    display: "block",
    color: "#222",
    textDecoration: "none",
    marginBottom: "6px",
};

export default Footer;